<script>
    import { user } from "../store/user.js";
    import { token } from "../store/token.js";

    import HeadingContent from "./component/HeadingContent.svelte";

    import { blur } from "svelte/transition";

    let expanded_change_picture = false;
    let expanded_change_password = true;
    let expanded_personal_info = true;

    let display_name = $user.artist_name || "";
    let name = $user.name || "";
    let occupation = $user.occupation || "";
    let bio = $user.bio || "";
    let website = $user.website || "";

    let user_email = $user.email;

    var submitted_state = false;

    let existing_password;
    let new_password;
    let new_password_again;

    function readURL(input) {
        console.log(input);
        if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = function (e) {
                //$("#new_image_preview").attr("src", e.target.result);
                document
                    .getElementById("new_image_preview")
                    .setAttribute("src", e.target.result);
            };

            reader.readAsDataURL(input.files[0]);
        }
    }

    var interval = setInterval(() => {
        try {
            document
                .getElementById("upload-photo")
                .addEventListener("change", (event) => {
                    readURL(event.target);
                    changeUser(true);
                });

            clearInterval(interval);
        } catch (e) {}
    }, 300);

    const changeUser = async (only_avatar) => {
        submitted_state = true;
        var update_user_url = new URL(`${process.env.API_ROOT}/user`);

        let formData = new FormData();

        if (only_avatar) {
            if (document.getElementById("upload-photo").files[0]) {
                formData.append(
                    "avatar",
                    document.getElementById("upload-photo").files[0],
                );
            }
        }

        if (!only_avatar) {
            formData.append("email", user_email);
            formData.append("name", name);
            formData.append("occupation", occupation);
            formData.append("bio", bio);
            formData.append("website", website);
            formData.append("artist_name", display_name);
        }

        const update_user_response = await fetch(update_user_url, {
            method: "put",
            headers: {
                Authorization: "Bearer " + $token,
            },
            body: formData,
        });

        var update_user_json = await update_user_response.json();

        user.set(update_user_json);

        submitted_state = false;

        var interval = setInterval(() => {
            try {
                document
                    .getElementById("upload-photo")
                    .addEventListener("change", (event) => {
                        readURL(event.target);
                        changeUser(true);
                    });

                clearInterval(interval);
            } catch (e) {}
        }, 300);
    };

    const change_password = () => {
        submitted_state = true;
        fetch(`${process.env.API_ROOT}/user/password/update`, {
            method: "POST",
            mode: "cors",
            headers: {
                Authorization: "Bearer " + $token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                new_password: new_password,
                new_password_again: new_password_again,
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
            })
            .catch(console.log)
            .finally(() => {
                submitted_state = false;
            });
    };

    console.log($user);

    let delete_user_modal_shown = false;

    const show_hide_delete_user = () => {
        delete_user_modal_shown = !delete_user_modal_shown;
    };

    let input_user_email;
    let input_user_password;

    const delete_user = async () => {
        var delete_user_url = new URL(
            `${process.env.API_ROOT}/user/account/delete`,
        );

        const delete_user_response = await fetch(delete_user_url, {
            method: "post",
            headers: {
                Authorization: "Bearer " + $token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                email: input_user_email,
                password: input_user_password,
            }),
        });

        if (delete_user_response.status >= 200 && delete_user_response.status < 400) {
                    token.set("");
                    user.set({});
            
                    set_section("public/login");
        } else {
            alert("Delete account operation was not successful.")
        }
    };
</script>

<div class="settings-holder settings-active">
    <!-- Settings General Overview (First Level) (the items of the menu of Security)-->
    <div class="settings-holder-content content-active">
        <HeadingContent title="General" back_button_enabled={false}/>
        <!--<div class="settings-heading">
            <div class="d-md-none">
                <div class="heading-block">
                    <a class="nav-opener" href="#a"
                        ><i class="icon icon-navigation" /></a
                    ><a class="nav-back" href="#b">
                        <div class="ico-holder">
                            <i class="icon icon-chevron-left" />
                        </div>
                        <div class="ico-holder">
                            <i class="icon icon-user" />
                        </div>
                        <div class="title-holder">
                            <strong class="settings-title">General</strong>
                        </div></a
                    >
                </div>
            </div>
            <div class="d-none d-md-block">
                <div class="heading-block">
                    <h1 class="h6 settings-title">General</h1>
                </div>
            </div>
        </div>
        -->
        <div class="settings-content">
            <div class="settings-content-holder">
                <div class="card-user card">
                    {#if expanded_change_picture}
                        <div in:blur class="card-body">
                            <div class="user-block">
                                <div
                                    class="avatar"
                                    style="background-color: {$user.name_background_color}; color: {$user.name_text_color};"
                                >
                                    {#if $user.avatar_url}
                                        <img
                                            loading="lazy"
                                            alt=""
                                            class="image-preview"
                                            id="new_image_preview"
                                            src={$user.avatar_url}
                                        />
                                    {:else}
                                        {$user.name_abbreviation}
                                    {/if}

                                    <!-- img(src='images/person-jacob.jpg', alt='image description', width='42' height='42')-->
                                </div>
                            </div>
                            <div class="mx-auto">
                                {#if submitted_state == false}
                                    <label
                                        for="upload-photo"
                                        href="#a"
                                        class="btn btn-primary"
                                        style="cursor:pointer"
                                        >Upload new image
                                        <input
                                            type="file"
                                            name="new_avatar"
                                            id="upload-photo"
                                        /></label
                                    >
                                {:else}
                                    <span
                                        class="btn btn-primary"
                                        style="cursor:pointer"
                                        ><img
                                            src="images/spinner.svg"
                                            alt="vollume"
                                            width="20"
                                            height="20"
                                        /> Saving</span
                                    >
                                {/if}
                            </div>
                        </div>
                    {:else}
                        <div
                            class="card-body card-body-collapsed"
                            on:click={() => {
                                expanded_change_picture =
                                    !expanded_change_picture;
                            }}
                        >
                            <div
                                class="user-block user-block-collapsed"
                                style="display: flex;"
                            >
                                <div
                                    class="avatar avatar-collapsed"
                                    style="background-color: {$user.name_background_color}; color: {$user.name_text_color}; font-size: 1rem"
                                >
                                    {#if $user.avatar_url}
                                        <img
                                            loading="lazy"
                                            alt=""
                                            class="image-preview-collapsed"
                                            id="new_image_preview"
                                            src={$user.avatar_url}
                                        />
                                    {:else}
                                        {$user.name_abbreviation}
                                    {/if}
                                    <!-- img(src='images/person-jacob.jpg', alt='image description', width='42' height='42')-->
                                </div>

                                <div class="mx-auto">
                                    <button
                                        class="btn btn-primary btn-collapsed"
                                        style="cursor:pointer"
                                        >Change Profile Picture</button
                                    >
                                </div>
                            </div>
                        </div>
                    {/if}
                </div>
                <div class="card-personal card">
                    {#if expanded_change_password}
                        <div class="card-body" in:blur>
                            <div class="card-block">
                                <h2 class="h6 card-title">Password Change</h2>
                            </div>
                            <div class="card-form-block">
                                <div class="form-group">
                                    <input
                                        id="password-current"
                                        type="password"
                                        name="display-name-personal"
                                        placeholder="Enter existing password"
                                        data-required="true"
                                        bind:value={existing_password}
                                    />
                                    <div class="error">
                                        Enter existing password
                                    </div>
                                </div>
                                <div class="form-group">
                                    <input
                                        id="password-new"
                                        type="password"
                                        name="full-name-personal"
                                        placeholder="Enter new password"
                                        data-required="true"
                                        bind:value={new_password}
                                    />
                                    <div class="error">Enter new password</div>
                                </div>
                                <div class="form-group">
                                    <input
                                        id="password-new-again"
                                        type="password"
                                        name="full-name-personal"
                                        placeholder="Enter new password again"
                                        data-required="true"
                                        bind:value={new_password_again}
                                    />
                                    <div class="error">
                                        Enter password again
                                    </div>
                                </div>
                                <div class="button-holder text-md-right">
                                    {#if submitted_state}
                                        <span
                                            class="btn btn-primary"
                                            style="cursor:pointer"
                                            ><img
                                                src="images/spinner.svg"
                                                alt="vollume"
                                                width="20"
                                                height="20"
                                            /> Saving</span
                                        >
                                    {:else}
                                        <span
                                            class="btn btn-primary"
                                            style="cursor:pointer"
                                            on:click={() => {
                                                change_password();
                                            }}>Save password</span
                                        >
                                    {/if}
                                </div>
                            </div>
                        </div>
                    {:else}
                        <div
                            class="card-body card-body-collapsed"
                            on:click={() => {
                                expanded_change_password =
                                    !expanded_change_password;
                            }}
                        >
                            <div
                                class="user-block user-block-collapsed"
                                style="display: flex;"
                            >
                                <div class="card-block card-block-collapsed">
                                    <h2
                                        class="h6 card-title card-title-collapsed"
                                    >
                                        Manage Access
                                    </h2>
                                </div>

                                <div class="mx-auto">
                                    <button
                                        class="btn btn-primary btn-collapsed"
                                        style="cursor:pointer"
                                        >Change password</button
                                    >
                                </div>
                            </div>
                        </div>
                        <!--
                        <div class="card-body">
                            <div class="card-block">
                                <h2 class="h6 card-title">Password Change</h2>
                            </div>
                            <div class="card-form-block">
                                <div class="form-group">
                                    <input
                                        id="password-current"
                                        type="text"
                                        name="display-name-personal"
                                        placeholder="Enter existing password"
                                        data-required="true"
                                    />
                                    <div class="error">
                                        Enter existing password
                                    </div>
                                </div>
                                <div class="form-group">
                                    <input
                                        id="password-new"
                                        type="text"
                                        name="full-name-personal"
                                        placeholder="Enter new password"
                                        data-required="true"
                                    />
                                    <div class="error">Enter new password</div>
                                </div>
                                <div class="form-group">
                                    <input
                                        id="password-new-again"
                                        type="text"
                                        name="full-name-personal"
                                        placeholder="Enter new password again"
                                        data-required="true"
                                    />
                                    <div class="error">
                                        Enter password again
                                    </div>
                                </div>
                            </div>
                        </div>
                        -->
                    {/if}
                </div>

                <div class="card-personal card">
                    {#if expanded_personal_info}
                        <div class="card-body" in:blur>
                            <div class="card-block">
                                <h2 class="h6 card-title">Personal Info</h2>
                                <p>
                                    Enter a nickname and your real full name to
                                    make it easy for friends to find your
                                    Vollume profile
                                </p>
                                <!--<div class="button-holder">
                                <a class="btn btn-sm btn-dark" href="#"
                                    >Change Password</a
                                >
                            </div>-->
                            </div>
                            <div class="card-form-block">
                                <div class="form-group">
                                    <input
                                        id="display-name-personal"
                                        type="text"
                                        name="display-name-personal"
                                        placeholder="Display Name"
                                        data-required="true"
                                        bind:value={display_name}
                                    />
                                    <div class="error">Enter a valid Name</div>
                                </div>
                                <div class="form-group">
                                    <input
                                        id="full-name-personal"
                                        type="text"
                                        name="full-name-personal"
                                        placeholder="Full Name"
                                        data-required="true"
                                        bind:value={name}
                                    />
                                    <div class="error">Enter a valid Name</div>
                                </div>
                                <div class="form-group">
                                    <input
                                        id="email-personal"
                                        type="email"
                                        name="email-personal"
                                        placeholder="Email"
                                        data-required="true"
                                        bind:value={user_email}
                                    />
                                    <div class="error">Enter a valid Email</div>
                                </div>
                                <div class="form-group">
                                    <input
                                        id="occupation-personal"
                                        type="text"
                                        name="occupation-personal"
                                        placeholder="Occupation"
                                        data-required="true"
                                        bind:value={occupation}
                                    />
                                    <div class="error">
                                        Enter a valid Occupation
                                    </div>
                                </div>
                                <div class="form-group">
                                    <input
                                        id="bio-personal"
                                        type="text"
                                        name="bio-personal"
                                        placeholder="Bio"
                                        data-required="true"
                                        bind:value={bio}
                                    />
                                    <div class="error">Enter a valid Bio</div>
                                </div>
                                <div class="form-group">
                                    <input
                                        id="website-personal"
                                        type="text"
                                        name="website-personal"
                                        placeholder="Website"
                                        data-required="true"
                                        bind:value={website}
                                    />
                                    <div class="error">
                                        Enter a valid Website
                                    </div>
                                </div>
                                <div class="button-holder text-md-right">
                                    <span
                                        class="btn btn-dark"
                                        style="cursor:pointer"
                                        on:click={() => {
                                            show_hide_delete_user();
                                        }}>Delete account</span
                                    >

                                    {#if submitted_state}
                                        <span
                                            class="btn btn-primary"
                                            style="cursor:pointer"
                                            ><img
                                                src="images/spinner.svg"
                                                alt="vollume"
                                                width="20"
                                                height="20"
                                            /> Saving</span
                                        >
                                    {:else}
                                        <span
                                            class="btn btn-primary"
                                            style="cursor:pointer"
                                            on:click={() => {
                                                changeUser(false);
                                            }}>Save changes</span
                                        >
                                    {/if}
                                </div>
                            </div>
                        </div>
                    {:else}
                        <div
                            class="card-body card-body-collapsed"
                            on:click={() => {
                                expanded_personal_info =
                                    !expanded_personal_info;
                            }}
                        >
                            <div
                                class="user-block user-block-collapsed"
                                style="display: flex;"
                            >
                                <div class="card-block card-block-collapsed">
                                    <h2
                                        class="h6 card-title card-title-collapsed"
                                    >
                                        Personal Info
                                    </h2>
                                </div>

                                <div class="mx-auto">
                                    <button
                                        class="btn btn-primary btn-collapsed"
                                        style="cursor:pointer">Update</button
                                    >
                                </div>
                            </div>
                        </div>{/if}
                </div>
            </div>
        </div>
    </div>
</div>

<div
    class="popup-overlay"
    style={delete_user_modal_shown == false ? "display:none" : ""}
>
    <div class="popup-container" style="margin-top:10%">
        <div class="popup-card">
            <h3 class="h6 box-title">Delete Account</h3>
            <div class="mb-24">
                <div class="f-white">
                    If you're sure that you want to delete your account, please enter your username and password below, then press "Delete Account".
                    <br /><br />
                    Your account will enter a 30 day deactivation period, were after 30 days, your account will be permanently deleted. Once your account is deleted, it can not be recovered.
                    <br /><br />
                    If you'd like to reactivate your account before that happens, just log in to Vollume and the deletion process will be cancelled.
                </div>
            </div>
            <div class="mb-24">
                <div>
                    <br />
                    To confirm, please enter your email and password.
                </div>
            </div>
            <div class="w-form" style="margin-top: 20px;">
                <form
                    id="email-form-3"
                    name="email-form-3"
                    data-name="Email Form 3"
                    method="get"
                >
                    <input
                        type="email"
                        class="field w-input"
                        maxlength="256"
                        name="name"
                        data-name="Name"
                        placeholder="Enter your email"
                        id="name"
                        bind:value={input_user_email}
                    /><input
                        type="password"
                        class="field w-input"
                        maxlength="256"
                        name="email-3"
                        data-name="Email 3"
                        placeholder="Password"
                        id="email-3"
                        required=""
                        bind:value={input_user_password}
                    />
                </form>
            </div>
            <div class="popup-actions">
                <div class="df-row df-aic df-md-jce gx-1">
                    <div class="col-md-auto">
                        <a
                            class="btn btn-dark"
                            href="#b"
                            on:click={() => {
                                show_hide_delete_user();
                            }}>Cancel</a
                        >
                    </div>
                    <div class="col-md-auto">
                        <a
                            class="btn btn-danger"
                            href="#a"
                            on:click={() => {
                                delete_user();
                            }}>Delete Account</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    #upload-photo {
        opacity: 0;
        position: absolute;
        z-index: -1;
    }

    .image-preview {
        clip-path: circle(71px at center);
    }
    .image-preview-collapsed {
        clip-path: circle(25px at center);
        width: 50px;
        height: 50px;
    }

    .avatar-collapsed {
        height: 50px;
        width: 50px;
        margin-bottom: 0px !important;
        margin-right: 25px !important;
    }

    .card-body-collapsed {
        padding-top: 25px !important;
    }

    .btn-collapsed {
        margin-top: 9px !important;
        min-width: 200px;
    }
    .user-block-collapsed {
        justify-content: space-between;
    }

    .card-block-collapsed {
        margin: 0 !important;
        padding: 0 !important;
    }

    .card-title-collapsed {
        margin-bottom: 0 !important;
    }
</style>
